import { Text } from '@chakra-ui/react';
import { type FC } from 'react';

import { type MaterialFilterOption } from '$/services/usecases/materials';

interface Props {
  isExpanded: boolean;
  activeFilter?: MaterialFilterOption;
  compactMode?: boolean;
}

export const ActiveFilterText: FC<Props> = ({
  isExpanded,
  activeFilter,
  compactMode = false,
}) => {
  if (isExpanded || !activeFilter) return null;

  const label = Array.isArray(activeFilter.value)
    ? activeFilter.value.join(', ')
    : activeFilter.value;

  return (
    <Text
      maxW={compactMode ? '165px' : undefined}
      mb={compactMode ? '0' : '2'}
      ml={compactMode ? '4' : '5'}
      fontSize='sm'
    >
      {label}
    </Text>
  );
};
